import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import PendingApproval from "@/pages/PendingApproval";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <Loader2 className="h-8 w-8 animate-spin text-[#14382C]" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (user.approved === false) return <PendingApproval />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}
